import styled from "styled-components";
import { useModalContext } from "../ModalContext";
import { IconName, IconSize, PlainIcon } from "../../Icon";
import { alpha } from "../../../typography";

const TitleRow = styled.header`
  flex-grow: 0;
  order: -1;
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-000-full);

  h2 {
    flex-grow: 1;
    margin: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${alpha.primaryActive.subtitle1};
  }

  > span {
    display: block;
    :first-child {
      margin-right: 8px;
    }
  }
`;

const CloseIconContainer = styled.span`
  margin-left: 16px;
  cursor: pointer;
  > span {
    display: block;
  }
`;

type TitleProps = {
  /** The title content to render. */
  children: string;

  /** An optional icon to render with the title. */
  iconName?: IconName;
  /** An optional size for the icon. Defaults to regular */
  iconSize?: IconSize;
};

export const Title = ({
  children,
  iconName,
  iconSize = "regular",
}: TitleProps) => {
  const { onClose } = useModalContext();
  return (
    <TitleRow>
      {iconName && <PlainIcon iconSize={iconSize} iconName={iconName} />}
      <h2>{children}</h2>
      <CloseIconContainer>
        <PlainIcon iconName="x-close" onClick={onClose} />
      </CloseIconContainer>
    </TitleRow>
  );
};
